import { useQuery } from '@tanstack/react-query'
import { getAlertData } from 'services/apiAlert'

const useGetAlertSettings = () => {
  const {isPending: isGetting,isError: isFailed,data: alertSettings} = useQuery({
    queryKey:['alertSettings'],
    queryFn: getAlertData,
    keepPreviousData: true,
    staleTime: 2 * 60 * 60 * 1000,
    
  })

  return {isGetting,isFailed,alertSettings}
}

export default useGetAlertSettings
